import SweepBaseApi from './base'
import {
  SweepNetwork,
  GetSweepNetworkInfoDTO,
  FindSweepAccountsDTO,
  SweepNetworkInfo,
  SaveOrUpdateDto,
  SaveOrUpdateSubmitDTO,
  CreateSweepAddressDTO,
} from './models'
import { DEFAULT_PAGE_SIZE } from '@/constants'
import { SweepAccountPagination, CreateSweepAddressResponseData } from './models'

class TxSweepApi extends SweepBaseApi {
  async getSweepGray() {
    return this.post<boolean>('/gray', undefined, {
      // 为了不弹出错误消息
      transformResponse: [
        function (data: string) {
          try {
            const obj = JSON.parse(data)
            if (obj.message) {
              obj.message = ''
            }
            return obj
          } catch (err) {
            return data
          }
        },
      ],
    })
  }

  async getSweepNetworkList() {
    return this.post<SweepNetwork[]>('/network/list')
  }

  async getSweepNetworkInfo(dto: GetSweepNetworkInfoDTO) {
    return this.post<SweepNetworkInfo>('/network/info', dto)
  }

  async findSweepAccounts(dto: FindSweepAccountsDTO) {
    return this.post<SweepAccountPagination>('/findAccountBySlide', {
      pageSize: DEFAULT_PAGE_SIZE,
      ...dto,
    })
  }

  async saveOrUpdate(dto: SaveOrUpdateDto) {
    return this.post('/policy/saveOrUpdate', dto)
  }

  async saveOrUpdateSubmit(dto: SaveOrUpdateSubmitDTO) {
    return this.post('/policy/saveOrUpdateSubmit', dto)
  }

  async submitAudit(modifyKey: string) {
    return this.post<boolean>('/policy/submitAudit', {
      modifyKey,
    })
  }

  async deleteSweep(modifyKey: string) {
    return this.post<boolean>('/policy/delete', {
      modifyKey,
    })
  }

  async scanSweep(networkKey: string) {
    return this.post<boolean>('/scan', {
      networkKey,
    })
  }

  async createAddress(dto: CreateSweepAddressDTO) {
    return this.post<CreateSweepAddressResponseData>('/sweepAddressCreate', dto)
  }
}

export default new TxSweepApi()
